/**
 * RichText — renderiza strings de i18n que contêm HTML simples (`<b>`, `<br/>`, `<i>`).
 *
 * SEGURANÇA: usa `dangerouslySetInnerHTML` APENAS com conteúdo dos nossos arquivos de tradução
 * (`src/i18n/locales/*.json`), que são estáticos e confiáveis — NUNCA com dados de lead/usuário.
 * Isto reproduz o comportamento do legado (que usava `innerHTML` nos textos de i18n).
 */
import type { ElementType } from 'react';

interface RichTextProps {
  /** HTML confiável (de i18n). Não passar dados dinâmicos/usuário aqui. */
  html: string;
  as?: ElementType;
  className?: string;
  title?: string;
}

export function RichText({ html, as: Tag = 'span', className, title }: RichTextProps): JSX.Element {
  return <Tag className={className} title={title} dangerouslySetInnerHTML={{ __html: html }} />;
}
